// ShippingPolicy.jsx
import React from "react";

const ShippingPolicy = () => {
  return (
    <div className="shipping-policy-wrapper">
      <style>
        {`
          /* ===== RESET & BASE ===== */
          .shipping-policy-wrapper {
            background: #f9f7f4;
            min-height: 100vh;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            padding: 1.2rem 0.8rem 2rem;
            font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            box-sizing: border-box;
          }

          .shipping-policy-wrapper *,
          .shipping-policy-wrapper *::before,
          .shipping-policy-wrapper *::after {
            box-sizing: border-box;
            margin: 0;
            padding: 0;
          }

          .shipping-policy-container {
            max-width: 1200px;
            width: 100%;
            background: white;
            border-radius: 28px;
            box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.02);
            padding: 1.8rem 1.8rem 2rem;
            transition: padding 0.2s ease;
          }

          /* ===== HEADER ===== */
          .policy-header {
            margin-bottom: 2rem;
            border-bottom: 2px solid #f0ebe4;
            padding-bottom: 1.2rem;
          }

          .policy-header h1 {
            font-size: 2rem;
            font-weight: 700;
            letter-spacing: -0.02em;
            color: #1e1e1e;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          }

          .policy-header h1 i {
            font-size: 1.8rem;
            color: #d4a373;
          }

          .effective-date {
            font-size: 0.85rem;
            font-weight: 500;
            color: #5e5e5e;
            background: #f0ebe4;
            display: inline-block;
            padding: 0.2rem 0.9rem;
            border-radius: 40px;
            margin-top: 0.4rem;
          }

          .intro-text {
            margin-top: 0.8rem;
            font-size: 1rem;
            color: #2d2d2d;
            line-height: 1.6;
            background: #fcf9f6;
            padding: 0.8rem 1.2rem;
            border-radius: 14px;
            border-left: 4px solid #d4a373;
            font-weight: 500;
          }

          /* ===== POLICY SECTIONS ===== */
          .policy-sections {
            display: flex;
            flex-direction: column;
            gap: 1.2rem;
          }

          .policy-card {
            background: #ffffff;
            border-radius: 20px;
            padding: 1.2rem 1.5rem;
            border: 1px solid #f0ebe4;
            transition: border-color 0.2s, box-shadow 0.2s;
          }

          .policy-card:hover {
            border-color: #e2d6c8;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
          }

          .policy-card h2 {
            font-size: 1.15rem;
            font-weight: 600;
            color: #1e1e1e;
            margin-bottom: 0.8rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            border-bottom: 2px solid #f0ebe4;
            padding-bottom: 0.5rem;
          }

          .policy-card h2 i {
            font-size: 1.1rem;
            width: 1.6rem;
            text-align: center;
            color: #bc6c25;
          }

          .policy-card p,
          .policy-card li {
            font-size: 0.96rem;
            color: #2d2d2d;
            line-height: 1.7;
          }

          .policy-card ul {
            list-style: none;
            padding: 0;
            margin: 0.3rem 0 0 0;
          }

          .policy-card ul li {
            display: flex;
            align-items: flex-start;
            gap: 0.6rem;
            padding: 0.3rem 0;
          }

          .policy-card ul li i {
            min-width: 1.4rem;
            margin-top: 0.15rem;
            font-size: 0.9rem;
            color: #bc6c25;
          }

          .policy-card ul li strong {
            font-weight: 600;
            color: #1a1a1a;
          }

          .policy-card ul li .highlight {
            color: #bc6c25;
            font-weight: 600;
          }

          /* ===== SPECIAL BADGE / NOTE ===== */
          .note-badge {
            display: inline-flex;
            align-items: center;
            gap: 0.4rem;
            background: #fcf9f6;
            padding: 0.3rem 1rem;
            border-radius: 40px;
            font-size: 0.85rem;
            font-weight: 500;
            color: #1e1e1e;
            border: 1px solid #ede7df;
            margin-top: 0.4rem;
          }

          .note-badge i {
            color: #bc6c25;
          }

          /* ===== CONTACT CARD ===== */
          .contact-card {
            background: #fcf9f6;
            border: 1px solid #e2d6c8;
          }

          .contact-details {
            display: flex;
            flex-direction: column;
            gap: 0.7rem;
            margin-top: 0.4rem;
          }

          .contact-item {
            display: flex;
            align-items: center;
            gap: 0.8rem;
            font-size: 0.98rem;
            padding: 0.5rem 1rem;
            background: white;
            border-radius: 60px;
            border: 1px solid #ede7df;
            transition: background 0.2s, border-color 0.2s;
          }

          .contact-item i {
            width: 1.6rem;
            font-size: 1.1rem;
            color: #bc6c25;
            text-align: center;
          }

          .contact-item a {
            text-decoration: none;
            color: #1e1e1e;
            font-weight: 500;
            word-break: break-word;
            flex: 1;
          }

          .contact-item a:hover {
            color: #bc6c25;
            text-decoration: underline;
          }

          .contact-item:hover {
            background: #f7f2ec;
            border-color: #d4a373;
          }

          /* ===== FOOTER ===== */
          .policy-footer {
            margin-top: 2.2rem;
            text-align: center;
            font-size: 0.85rem;
            color: #5e5e5e;
            border-top: 1px solid #f0ebe4;
            padding-top: 1.2rem;
          }

          /* ===== RESPONSIVE (mobile-first) ===== */
          @media (max-width: 700px) {
            .shipping-policy-wrapper {
              padding: 0.6rem 0.4rem 1.2rem;
            }

            .shipping-policy-container {
              padding: 1rem 0.8rem 1.5rem;
              border-radius: 20px;
            }

            .policy-header h1 {
              font-size: 1.6rem;
            }

            .policy-header h1 i {
              font-size: 1.4rem;
            }

            .intro-text {
              font-size: 0.92rem;
              padding: 0.6rem 0.9rem;
            }

            .policy-card {
              padding: 0.9rem 1rem;
              border-radius: 16px;
            }

            .policy-card h2 {
              font-size: 1.05rem;
              margin-bottom: 0.6rem;
            }

            .policy-card p,
            .policy-card li {
              font-size: 0.9rem;
            }

            .policy-card ul li {
              padding: 0.2rem 0;
            }

            .contact-item {
              font-size: 0.9rem;
              padding: 0.4rem 0.8rem;
              gap: 0.6rem;
            }

            .contact-item i {
              width: 1.4rem;
              font-size: 1rem;
            }

            .effective-date {
              font-size: 0.75rem;
            }

            .note-badge {
              font-size: 0.8rem;
              padding: 0.2rem 0.8rem;
            }

            .policy-footer {
              font-size: 0.78rem;
              margin-top: 1.8rem;
              padding-top: 1rem;
            }
          }

          @media (max-width: 480px) {
            .shipping-policy-container {
              padding: 0.8rem 0.6rem 1.2rem;
              border-radius: 16px;
            }

            .policy-header h1 {
              font-size: 1.3rem;
            }

            .policy-header h1 i {
              font-size: 1.2rem;
            }

            .policy-card {
              padding: 0.7rem 0.8rem;
              border-radius: 14px;
            }

            .policy-card h2 {
              font-size: 0.95rem;
              padding-bottom: 0.3rem;
            }

            .policy-card p,
            .policy-card li {
              font-size: 0.85rem;
              line-height: 1.6;
            }

            .policy-card ul li {
              padding: 0.15rem 0;
              gap: 0.4rem;
            }

            .policy-card ul li i {
              min-width: 1.2rem;
              font-size: 0.8rem;
            }

            .contact-item {
              font-size: 0.82rem;
              padding: 0.35rem 0.6rem;
              gap: 0.4rem;
              border-radius: 40px;
            }

            .contact-item i {
              width: 1.2rem;
              font-size: 0.9rem;
            }

            .intro-text {
              font-size: 0.85rem;
              padding: 0.5rem 0.7rem;
            }

            .effective-date {
              font-size: 0.7rem;
              padding: 0.15rem 0.7rem;
            }

            .note-badge {
              font-size: 0.75rem;
              padding: 0.15rem 0.7rem;
            }

            .policy-footer {
              font-size: 0.72rem;
              margin-top: 1.5rem;
              padding-top: 0.8rem;
            }
          }
        `}
      </style>

      <div className="shipping-policy-container">
        {/* Header */}
        <div className="policy-header">
          <h1>
            <i className="fas fa-truck"></i>
            Shipping &amp; Delivery Policy
          </h1>
          <p className="effective-date">Effective Date: 30 March 2026</p>
          <p className="intro-text">
            At Maamaa's, we are committed to delivering your orders promptly and safely.
          </p>
        </div>

        {/* Policy Sections */}
        <div className="policy-sections">
          {/* 1. Delivery Areas */}
          <section className="policy-card">
            <h2>
              <i className="fas fa-map-marker-alt"></i>
              1. Delivery Areas
            </h2>
            <p>
              We currently deliver orders to selected serviceable locations. Delivery availability depends on your location and the participating restaurant.
            </p>
          </section>

          {/* 2. Order Processing */}
          <section className="policy-card">
            <h2>
              <i className="fas fa-clock"></i>
              2. Order Processing
            </h2>
            <ul>
              <li>
                <i className="fas fa-check-circle"></i>
                Orders are processed immediately after successful payment and confirmation by the restaurant.
              </li>
              <li>
                <i className="fas fa-utensils"></i>
                Once an order is accepted, the restaurant begins preparing your food.
              </li>
            </ul>
          </section>

          {/* 3. Estimated Delivery Time */}
          <section className="policy-card">
            <h2>
              <i className="fas fa-hourglass-half"></i>
              3. Estimated Delivery Time
            </h2>
            <p>
              Estimated delivery times are displayed during checkout and may vary depending on:
            </p>
            <ul>
              <li><i className="fas fa-kitchen-set"></i> Restaurant preparation time</li>
              <li><i className="fas fa-route"></i> Distance to the delivery location</li>
              <li><i className="fas fa-car"></i> Traffic conditions</li>
              <li><i className="fas fa-cloud-rain"></i> Weather conditions</li>
              <li><i className="fas fa-chart-line"></i> Order volume</li>
            </ul>
            <div className="note-badge">
              <i className="fas fa-info-circle"></i>
              While we strive to deliver within the estimated time, delays may occasionally occur due to circumstances beyond our control.
            </div>
          </section>

          {/* 4. Delivery Charges */}
          <section className="policy-card">
            <h2>
              <i className="fas fa-coins"></i>
              4. Delivery Charges
            </h2>
            <p>
              Delivery charges, if applicable, are displayed during checkout before payment. Charges may vary depending on:
            </p>
            <ul>
              <li><i className="fas fa-arrows-left-right"></i> Delivery distance</li>
              <li><i className="fas fa-store"></i> Restaurant location</li>
              <li><i className="fas fa-tags"></i> Promotional offers</li>
              <li><i className="fas fa-fire"></i> Peak demand</li>
            </ul>
          </section>

          {/* 5. Order Tracking */}
          <section className="policy-card">
            <h2>
              <i className="fas fa-satellite-dish"></i>
              5. Order Tracking
            </h2>
            <p>
              Customers can track the status of their orders through the Maamaa's website or mobile application after the order is confirmed.
            </p>
          </section>

          {/* 6. Delivery Responsibility */}
          <section className="policy-card">
            <h2>
              <i className="fas fa-shield-alt"></i>
              6. Delivery Responsibility
            </h2>
            <p>
              Customers are requested to provide an accurate delivery address and contact number. Failure to provide correct information may result in delivery delays or unsuccessful delivery.
            </p>
          </section>

          {/* 7. Failed Delivery */}
          <section className="policy-card">
            <h2>
              <i className="fas fa-exclamation-circle"></i>
              7. Failed Delivery
            </h2>
            <p>If the delivery cannot be completed because:</p>
            <ul>
              <li><i className="fas fa-user-slash"></i> The customer is unavailable,</li>
              <li><i className="fas fa-map-pin"></i> The delivery address is incorrect or incomplete, or</li>
              <li><i className="fas fa-phone-slash"></i> The customer cannot be contacted,</li>
            </ul>
            <p style={{ marginTop: "0.5rem" }}>
              the order may be cancelled, and refunds (if any) will be processed according to our <strong className="highlight">Refund Policy</strong>.
            </p>
          </section>

          {/* 8. Contact Us */}
          <section className="policy-card contact-card">
            <h2>
              <i className="fas fa-headset"></i>
              8. Contact Us
            </h2>
            <p style={{ marginBottom: "0.6rem" }}>
              For any delivery-related questions, please contact us:
            </p>
            <div className="contact-details">
              <div className="contact-item">
                <i className="fas fa-envelope"></i>
                <a href="mailto:info@maamaas.com">info@maamaas.com</a>
              </div>
              <div className="contact-item">
                <i className="fas fa-globe"></i>
                <a href="https://www.maamaas.com" target="_blank" rel="noopener noreferrer">
                  https://www.maamaas.com
                </a>
              </div>
            </div>
          </section>
        </div>

        {/* Footer */}
        <div className="policy-footer">
          <p>
            <i className="fas fa-heart" style={{ color: "#bc6c25", marginRight: "0.3rem" }}></i>
            Maamaa's – delivering goodness, every time
          </p>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;